/**
 * Returns the URL to navigate to when the candidate exits the chat (skip survey,
 * submit survey, exit from call cancelled, connection lost, etc.).
 * When the chat is loaded inside the video_chat_frame (parent has chatFrameLocation),
 * the user should be sent to whatever #chat_browse is showing; otherwise use
 * afterChatPath or '/'.
 * @param {string} [afterChatPath] - Optional path/URL from the page (e.g. dashboard)
 * @returns {string} URL to use for exit/redirect
 */
export function getEffectiveExitUrl(afterChatPath) {
  try {
    if (
      typeof window !== 'undefined' &&
      window.parent &&
      window.parent !== window &&
      window.parent.chatFrameLocation
    ) {
      const ref = window.parent.chatFrameLocation
      return typeof ref === 'string' ? ref : ref.pathname || '/'
    }
  } catch (_e) {
    // Cross-origin or access error: fall back to afterChatPath
  }
  return afterChatPath || '/'
}
